import React from 'react'

function Inventory ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 405.332 405.332'>
      <path d='M405.332,405.332H0V0H405.332ZM21.332,384H384V21.332H21.332Zm0,0' />
      <path d='M10.668,128h384v21.332h-384Zm0,0' />
      <path d='M10.668,256h384v21.332h-384Zm0,0' />
      <path d='M256,320h85.332v21.332H256Zm0,0' />
      <path d='M256,192h85.332v21.332H256Zm0,0' />
      <path d='M256,64h85.332V85.332H256Zm0,0' />
      <path d='M64,320h42.668v21.332H64Zm0,0' />
      <path d='M64,192h42.668v21.332H64Zm0,0' />
      <path d='M64,64h42.668V85.332H64Zm0,0' />
    </svg>
  )
}

Inventory.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Inventory
